<template>
  <div v-if="!fieldLoading" class="full-height">
    <div v-if="windowWidth > 960" class="mt-4 d-flex justify-center">
      <div
        v-for="detail in progressDetails"
        :key="detail.type"
        class="text-center"
      >
        <div class="d-flex align-center">
          <div>
            <v-progress-circular
              :rotate="-90"
              :size="45"
              :width="5"
              :value="
                detail.value === selectedSection ||
                selectedSection > detail.value
                  ? 100
                  : 0
              "
              :color="selectedSection > detail.value ? 'green' : 'primary'"
            >
              <v-icon
                size="20"
                class="font-weight-bold"
                :color="selectedSection > detail.value ? 'green' : 'primary'"
              >
                {{
                  selectedSection > detail.value ? "check" : detail.icon
                }}</v-icon
              >
            </v-progress-circular>
            <div
              :class="{ 'font-weight-bold': detail.value === selectedSection }"
              class="body-2 mt-1"
              :color="
                selectedSection > detail.value
                  ? 'color: green'
                  : 'color: primary'
              "
            >
              <span
                :color="
                  selectedSection > detail.value
                    ? 'color: green'
                    : 'color: primary'
                "
              >
                {{ detail.heading }}
              </span>
            </div>
          </div>
          <div
            v-if="detail.type !== 'submit'"
            style="width: 70px; border-top: 2px dotted #b1afaf"
          ></div>
        </div>
      </div>
    </div>
    <PersonalDetails
      v-if="selectedSection === 0"
      @personal-details="setPersonalDetails($event)"
      @move-to-next-section="onClickNextSession(1)"
    ></PersonalDetails>
    <SkillProfiles
      v-else-if="selectedSection === 1"
      @back-to-prev="backToPreviousStep(0)"
      @experience-saved="onClickNextSession(2)"
    ></SkillProfiles>
    <Certification
      v-else-if="selectedSection === 2"
      @back-to-prev="backToPreviousStep(1)"
      @move-to-next-session="onClickNextSession(3)"
    ></Certification>
    <Accreditations
      v-else-if="selectedSection === 3"
      :personalDetails="personalDetails"
      @back-to-prev="backToPreviousStep(2)"
      @accreditations-saved="
        hideDocumentTab ? onClickNextSession(5) : onClickNextSession(4)
      "
    ></Accreditations>
    <Documents
      v-else-if="selectedSection === 4 && !hideDocumentTab"
      @back-to-prev="backToPreviousStep(3)"
      @documents-saved="onClickNextSession(5)"
    ></Documents>
    <BankInformation
      v-else-if="selectedSection === 5"
      :payroll-general-settings="payrollGeneralSettings"
      @back-to-prev="
        hideDocumentTab ? backToPreviousStep(3) : backToPreviousStep(4)
      "
      @bank-saved="
        hideJoiningKitTab ? onClickNextSession(7) : onClickNextSession(6)
      "
    ></BankInformation>
    <JoiningKit
      v-else-if="selectedSection === 6 && !hideJoiningKitTab"
      :joining-kit-document-details="joiningKitDocumentDetails"
      :candidate-id="candidateId"
      @back-to-prev="backToPreviousStep(5)"
      @joining-kit-saved="onClickNextSession(7)"
    ></JoiningKit>
    <DynamicCustomFields
      v-else-if="listCustomFields.length > 0 && selectedSection === 7"
      :list-custom-fields="listCustomFields"
      :list-loading="listLoading"
      :candidate-id="candidateId"
      @back-to-prev="
        hideJoiningKitTab ? backToPreviousStep(5) : backToPreviousStep(6)
      "
      @additional-saved="onClickNextSession(8)"
      @updated-dynamic-form="retrieveDynamicFieldValues('updated-dynamic-form')"
    />
    <FormSubmit
      v-else
      @back-to-prev="
        backToPreviousStep(
          listCustomFields.length > 0 ? 7 : hideJoiningKitTab ? 5 : 6
        )
      "
      @form-submitted="$emit('form-submitted')"
    ></FormSubmit>
  </div>
</template>

<script>
import PersonalDetails from "./personal-details/PersonalDetails.vue";
import SkillProfiles from "./skill-profile/SkillProfiles.vue";
import Certification from "./certification/Certification.vue";
import Accreditations from "./accreditations/Accreditations.vue";
import Documents from "./documents/Documents.vue";
import BankInformation from "./bank-details/BankInformation.vue";
import JoiningKit from "./joining-kit/JoiningKit.vue";
import FormSubmit from "./FormSubmit.vue";
import DynamicCustomFields from "./additional/DynamicCustomFields.vue";
import {
  RETRIEVE_DYNAMIC_FIELD_VALUES,
  GET_FORM_FIELDS_AND_TYPE,
  GET_DOCUMENT_SUBTYPES,
  RETRIEVE_DOCUMENT_DETAILS,
  RETRIEVE_PAYROLL_GENERAL_SETTINGS,
} from "../../graphql/OnboardingQueries";

export default {
  name: "Onboarding",

  components: {
    PersonalDetails,
    SkillProfiles,
    Certification,
    Accreditations,
    Documents,
    BankInformation,
    JoiningKit,
    DynamicCustomFields,
    FormSubmit,
  },

  data: () => ({
    selectedSection: null,
    personalDetails: {},
    payrollGeneralSettings: {},
    listCustomFields: [],
    listLoading: false,
    apiCallCount: 0,
    candidateId: null,
    progressDetails: [
      {
        type: "personal",
        value: 0,
        icon: "person",
        heading: "Personal Information",
      },
      {
        type: "skills",
        value: 1,
        icon: "business_center",
        heading: "Work Experience",
      },
      {
        type: "certification",
        value: 2,
        icon: "description",
        heading: "Certification",
      },
      {
        type: "accreditation",
        value: 3,
        icon: "article",
        heading: "Accreditation",
      },
      {
        type: "documents",
        value: 4,
        icon: "upload_file",
        heading: "Documents",
      },
      {
        type: "bank",
        value: 5,
        icon: "account_balance",
        heading: "Bank Information",
      },
      {
        type: "joiningKit",
        value: 6,
        icon: "folder_special",
        heading: "Joining Kit",
      },
      {
        type: "submit",
        value: 7,
        icon: "checklist_rtl",
        heading: "Submit",
      },
    ],
    formList: {},
    fieldLoading: false,
    hideDocumentTab: false,
    hideJoiningKitTab: false,
    joiningKitDocumentDetails: {},
  }),

  computed: {
    // current window size
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  mounted() {
    this.getFieldProps();
    this.getDocumentSubtypes();
    this.getJoiningKitDocumentDetails();
    this.getPayrollGeneralSettings();
    if (localStorage.getItem("currentScreen")) {
      this.selectedSection = parseInt(localStorage.getItem("currentScreen"));
    } else {
      this.selectedSection = 0;
    }
  },

  methods: {
    getFieldProps() {
      let vm = this;
      vm.fieldLoading = true;
      this.$apollo
        .query({
          query: GET_FORM_FIELDS_AND_TYPE,
          variables: {
            form_Id: 178,
          },
          client: "apolloClientB",
          fetchPolicy: "no-cache",
        })
        .then((res) => {
          if (res.data.getFormFeildsByFormIdAndTab) {
            res.data.getFormFeildsByFormIdAndTab.formFields.forEach((list) => {
              this.formList[list.Field_Id] = list;
            });
            if (this.formList[451]?.Field_Alias) {
              this.progressDetails[3].heading = this.formList[451]?.Field_Alias;
            }
          }
          vm.fieldLoading = false;
        })
        .catch(() => {
          vm.fieldLoading = false;
        });
    },
    getDocumentSubtypes() {
      let vm = this;
      vm.listLoading = true;
      this.$apollo
        .query({
          query: GET_DOCUMENT_SUBTYPES,
          client: "apolloClientD",
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (
            data &&
            data.listDocumentSubTypeDetails &&
            data.listDocumentSubTypeDetails.data &&
            data.listDocumentSubTypeDetails.data.length > 0
          ) {
            let documentSubTypes = data.listDocumentSubTypeDetails.data;
            let validDocuments = documentSubTypes.filter(
              (doc) => !doc.isDefault
            );
            this.hideDocumentTab = validDocuments.length === 0;
            if (this.hideDocumentTab) {
              this.progressDetails.splice(4, 1);
            }
          } else {
            this.hideDocumentTab = true;
          }
          vm.listLoading = false;
        })
        .catch(() => {
          this.hideDocumentTab = true;
          vm.listLoading = false;
        });
    },
    getJoiningKitDocumentDetails() {
      let vm = this;
      vm.$apollo
        .query({
          query: RETRIEVE_DOCUMENT_DETAILS,
          client: "apolloClientB",
        })
        .then((res) => {
          let documentDetails =
            res?.data?.retrieveDocumentDetails?.documentDetails;
          let parsedDocumentDetails = documentDetails;

          this.joiningKitDocumentDetails = parsedDocumentDetails || {};
          // Check if documentData is empty or has no data
          this.hideJoiningKitTab =
            !parsedDocumentDetails ||
            Object.keys(parsedDocumentDetails).length === 0 ||
            !parsedDocumentDetails?.documentTemplateId;

          if (this.hideJoiningKitTab) {
            // Find and remove the Joining Kit tab from progressDetails
            const joiningKitIndex = this.progressDetails.findIndex(
              (detail) => detail.type === "joiningKit"
            );
            if (joiningKitIndex !== -1) {
              this.progressDetails.splice(joiningKitIndex, 1);
            }
          }
        })
        .catch(() => {
          // On error, hide the Joining Kit tab
          this.hideJoiningKitTab = true;
          this.joiningKitDocumentDetails = {};
          const joiningKitIndex = this.progressDetails.findIndex(
            (detail) => detail.type === "joiningKit"
          );
          if (joiningKitIndex !== -1) {
            this.progressDetails.splice(joiningKitIndex, 1);
          }
        });
    },
    retrieveDynamicFieldValues(action = "") {
      try {
        this.listLoading = true;
        this.$apollo
          .query({
            query: RETRIEVE_DYNAMIC_FIELD_VALUES,
            client: "apolloClientE",
            variables: {
              formId: 178,
              primaryId: this.candidateId,
            },
            fetchPolicy: "no-cache",
          })
          .then((response) => {
            if (
              response?.data &&
              response.data.retrieveDynamicFieldValues &&
              response.data.retrieveDynamicFieldValues
                .dynamicGroupingFieldValues
            ) {
              let list = JSON.parse(
                response.data.retrieveDynamicFieldValues.dynamicFieldValues
              );
              const tempData = JSON.parse(
                response.data.retrieveDynamicFieldValues
                  .dynamicGroupingFieldValues
              );
              tempData.forEach((section) => {
                if (section.entries.length === 0)
                  section.entries.push({
                    Custom_Field_Value_Id: null,
                    fields: section.fields,
                  });
                else
                  section.entries.forEach((entry) => {
                    entry.fields = JSON.parse(JSON.stringify(section.fields));
                    entry.fields.forEach((field) => {
                      field.Value = entry.values[field.Custom_Field_Id];
                    });
                  });
              });
              tempData.sort(
                (a, b) => (a.Section_Order_By || 0) - (b.Section_Order_By || 0)
              );
              this.listCustomFields = tempData;
              if (list?.length && action !== "updated-dynamic-form") {
                this.progressDetails.splice(
                  this.progressDetails.length - 1,
                  0,
                  {
                    type: "custom-fields",
                    value: 7,
                    icon: "article",
                    heading: "Additional Details",
                  }
                );
                this.progressDetails[this.progressDetails.length - 1].value = 8;
              }
              this.listLoading = false;
            }
          });
      } catch (err) {
        this.listLoading = false;
        let snackbarData = {
          isOpen: true,
          message:
            err.graphQLErrors && err.graphQLErrors.length !== 0
              ? err.graphQLErrors[0].message
              : "Something went wrong. It could be a possibility due to network connectivity error..",
          type: "warning",
        };
        this.showAlert(snackbarData);
      }
    },
    getPayrollGeneralSettings() {
      this.$apollo
        .query({
          query: RETRIEVE_PAYROLL_GENERAL_SETTINGS,
          client: "apolloClientE",
          fetchPolicy: "no-cache",
        })
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.listPayrollGeneralSettings &&
            response.data.listPayrollGeneralSettings
              .listPayrollGeneralSettingsData?.length > 0
          ) {
            this.payrollGeneralSettings =
              response.data.listPayrollGeneralSettings
                .listPayrollGeneralSettingsData[0] || {};
          }
        })
        .catch(() => {
          this.payrollGeneralSettings = {};
        });
    },
    onClickNextSession(nextStep) {
      this.selectedSection = nextStep;
    },
    backToPreviousStep(toStep) {
      this.selectedSection = toStep;
    },
    // show error or success message
    showAlert(snackbarData) {
      this.$store.commit("OPEN_SNACKBAR", snackbarData);
    },
    setPersonalDetails(basicInfo) {
      if (basicInfo?.Candidate_Id) {
        this.candidateId = parseInt(basicInfo?.Candidate_Id);
        // Store Candidate_Id in localStorage until form is submitted
        localStorage.setItem("Candidate_Id", basicInfo.Candidate_Id);
        if (this.apiCallCount === 0) {
          this.retrieveDynamicFieldValues();
          this.apiCallCount++;
        }
      }
    },
  },
};
</script>
